import type { ReactNode } from 'react';

export function FormDivider(props: { children?: ReactNode }) {
    return <div className="divider">{props.children}</div>;
}
